export default __webpack_public_path__ + "static/media/leboncoin-logo.76a71dee.png";